import React, { useEffect, createElement } from 'react';
import { CountdownTimer } from './components/CountdownTimer';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { HowItWorks } from './components/HowItWorks';
import { PackContents } from './components/PackContents';
import { BeforeAfter } from './components/BeforeAfter';
import { BonusSection } from './components/BonusSection';
import { PricingSection } from './components/PricingSection';
import { Testimonials } from './components/Testimonials';
import { ClosingSection } from './components/ClosingSection';
import { SocialProofPopup } from './components/SocialProofPopup';
// Meta Pixel Types
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
export function App() {
  useEffect(() => {
    // Meta Pixel Initialization
    if (!window.fbq) {
      const n: any = window.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      window._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
    }
    window.fbq('init', '2032586933980278');
    window.fbq('track', 'PageView');
  }, []);
  return <div className="font-sans antialiased text-gray-900 bg-amber-50/30 min-h-screen pb-4" data-id="element-0">
      <CountdownTimer data-id="element-1" />

      <main className="mt-8" data-id="element-2">
        {' '}
        {/* Offset for fixed timer */}
        <HeroSection data-id="element-3" />
        <ProblemSection data-id="element-4" />
        <SolutionSection data-id="element-5" />
        <HowItWorks data-id="element-6" />
        <PackContents data-id="element-7" />
        <BeforeAfter data-id="element-8" />
        <BonusSection data-id="element-9" />
        <PricingSection data-id="element-10" />
        <Testimonials data-id="element-11" />
        <ClosingSection data-id="element-12" />
      </main>

      <footer className="bg-purple-50/40 py-4 text-center text-sm text-gray-500 border-t border-purple-100/50" data-id="element-13">
        <div className="max-w-4xl mx-auto px-4" data-id="element-14">
          <p data-id="element-15">
            © {new Date().getFullYear()} Creando Recuerdos Reales. Todos los
            derechos reservados.
          </p>
          <p className="mt-2" data-id="element-16">
            Este sitio no es parte del sitio web de Facebook o Facebook Inc.
            Además, este sitio no está respaldado por Facebook de ninguna
            manera. FACEBOOK es una marca registrada de FACEBOOK, Inc.
          </p>
        </div>
      </footer>

      <SocialProofPopup data-id="element-17" />
    </div>;
}